import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const DEMO_EMAIL_DOMAIN = '@constructionco.uk';

/**
 * DemoModeToast — renders a fixed bottom-right toast whenever a write
 * operation is intercepted in demo mode. Listens to the 'demo-mode-action'
 * custom window event dispatched by useDemoMode's guardAction.
 */
const DemoModeToast = () => {
  const { user, isDemoAdmin } = useAuth();
  const [visible, setVisible] = useState(false);
  const timerRef = React.useRef(null);

  const isDemoMode =
    isDemoAdmin ||
    (!!user?.email && user?.email?.endsWith(DEMO_EMAIL_DOMAIN));

  const showToast = useCallback(() => {
    setVisible(true);
    if (timerRef?.current) clearTimeout(timerRef?.current);
    timerRef.current = setTimeout(() => setVisible(false), 3000);
  }, []);

  useEffect(() => {
    if (!isDemoMode) return;
    window.addEventListener('demo-mode-action', showToast);
    return () => {
      window.removeEventListener('demo-mode-action', showToast);
      if (timerRef?.current) clearTimeout(timerRef?.current);
    };
  }, [isDemoMode, showToast]);

  if (!isDemoMode || !visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 right-6 z-[9999] flex items-center gap-3 bg-slate-800 border border-slate-600 text-slate-100 text-sm font-medium px-4 py-3 rounded-xl shadow-2xl transition-all duration-300"
    >
      <span className="w-2 h-2 rounded-full bg-amber-400 flex-shrink-0" />
      Demo mode: changes are not saved.
    </div>
  );
};

export default DemoModeToast;
